module.exports = __webpack_public_path__ + "static/img/leave.f5c0fee1.png";